import { render } from "./LanguageLabel.vue?vue&type=template&id=64892c84&scoped=true&ts=true"
import script from "./LanguageLabel.vue?vue&type=script&lang=ts"
export * from "./LanguageLabel.vue?vue&type=script&lang=ts"

import "./LanguageLabel.vue?vue&type=style&index=0&id=64892c84&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.41_vue@3.5.41_typescript@5.9.3__webpack@5.109.2_postcss@8.5.26_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64892c84"]])

export default __exports__